var imgGalElements = document.getElementsByClassName('img-gal');
if (imgGalElements.length > 0) {
  var newImagegal = document.createElement('div');
  newImagegal.className = 'main-image';
  for (var i = 0; i < imgGalElements.length; i++) {
    imgGalElements[i].classList.replace('img-gal', 'thumb-image');
  }
  var elements = document.getElementsByClassName('thumb-image');
  var anchorElements = document.querySelectorAll('.thumb-image a');
  for (var i = 0; i < anchorElements.length; i++) {
    anchorElements[i].setAttribute('href', 'javascript:void(0)');
  }
  var combinedInnerHTML = '';
  for (var i = 0; i < elements.length; i++) {
    combinedInnerHTML += elements[i].innerHTML;
  }
  newImagegal.innerHTML = combinedInnerHTML;
  var firstThumbImage = elements[0];
  firstThumbImage.parentNode.insertBefore(newImagegal, firstThumbImage);
}

$('.thumb-image').not('.slick-initialized').slick({
  slidesToShow: 5,
  slidesToScroll: 2,
  infinite: true,
  arrows: false,
  centerMode: true,
  focusOnSelect: true,
  asNavFor: '.main-image',
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});

$('.main-image').not('.slick-initialized').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.thumb-image',
  infinite: true,
  arrows: true,
  prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg width="46" height="46" viewBox="0 0 46 46" fill="none" ><g id="Group 2849"><g ><path d="M23 44C34.598 44 44 34.598 44 23C44 11.402 34.598 2 23 2C11.402 2 2 11.402 2 23C2 34.598 11.402 44 23 44Z" fill="#0F0F0F"/><path d="M23 45C35.1503 45 45 35.1503 45 23C45 10.8497 35.1503 1 23 1C10.8497 1 1 10.8497 1 23C1 35.1503 10.8497 45 23 45Z" stroke="white" stroke-opacity="0.32" stroke-width="2" stroke-linejoin="round"/></g><path d="M19.8713 22.2287L23.8943 18.0909L22.8336 17L17 23L22.8336 29L23.8943 27.9091L19.8713 23.7714H29V22.2287H19.8713Z" fill="white"/></g></svg></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg width="46" height="46" viewBox="0 0 46 46" fill="none" ><g id="Group 2849"><g ><path d="M23 44C34.598 44 44 34.598 44 23C44 11.402 34.598 2 23 2C11.402 2 2 11.402 2 23C2 34.598 11.402 44 23 44Z" fill="#0F0F0F"/><path d="M23 45C35.1503 45 45 35.1503 45 23C45 10.8497 35.1503 1 23 1C10.8497 1 1 10.8497 1 23C1 35.1503 10.8497 45 23 45Z" stroke="white" stroke-opacity="0.32" stroke-width="2" stroke-linejoin="round"/></g><path d="M26.1287 22.2287L22.1057 18.0909L23.1664 17L29 23L23.1664 29L22.1057 27.9091L26.1287 23.7714H17V22.2287H26.1287Z" fill="white"/></g></svg></button>',
  adaptiveHeight: false,
});












// Only run accordion logic on specific blog article URLs
(function () {
  var path = window.location.pathname || "";

  var allowed =
    path.indexOf("/blogs/featured-systems/") === 0 ||
    path.indexOf("/blogs/artist-spotlight/") === 0;

  if (!allowed) return;


  
var articleContent = $(".article-template__content");
var h3Elements = articleContent.find("h3");
if (h3Elements.length > 1) {
  var lastH3Element = $(".article-template__content h3").last();
  lastH3Element.addClass("accordion-wrapper-title");
  var titleH3Element = $(".accordion-wrapper-title");
  var pElements = titleH3Element.nextAll();
  var newDiv = $("<div>").addClass("accordion-wrapper");
  newDiv.append(pElements);
  titleH3Element.after(newDiv);
  var accordionChildren = $(".accordion-wrapper > *");
  var hasQuestionOrInlineImg = false;
  accordionChildren.each(function () {
    if ($(this).hasClass("question") || $.trim($(this).text()) !== '') {
      hasQuestionOrInlineImg = true;
    }
    if ($(this).hasClass("inline-img")) {
      hasQuestionOrInlineImg = true;
      $(this).addClass("answer");
    }
    if ($(this).hasClass("center")) {
      hasQuestionOrInlineImg = true;
      $(this).addClass("answer");
    }
  });
  if (!hasQuestionOrInlineImg) {
    accordionChildren.addClass("answer");
  }
  var pElementsInAccordion = $(".accordion-wrapper > p");
  pElementsInAccordion.each(function () {
    if (!$(this).hasClass("question") && !$(this).hasClass("answer")) {
      $(this).addClass("answer");
    }
  });
}
else if (h3Elements.length >= 1) {
  var lastH3Element = $(".article-template__content h3");
  lastH3Element.addClass("accordion-wrapper-title");
  var titleH3Element = $(".accordion-wrapper-title");
  var pElements = titleH3Element.nextAll();
  var newDiv = $("<div>").addClass("accordion-wrapper");
  newDiv.append(pElements);
  titleH3Element.after(newDiv);
  var accordionChildren = $(".accordion-wrapper > *");
  var hasQuestionOrInlineImg = false;
  accordionChildren.each(function () {
    if ($(this).hasClass("question") || $.trim($(this).text()) !== '') {
      hasQuestionOrInlineImg = true;
    }
    if ($(this).hasClass("inline-img")) {
      hasQuestionOrInlineImg = true;
      $(this).addClass("answer");
    }
    if ($(this).hasClass("center")) {
      hasQuestionOrInlineImg = true;
      $(this).addClass("answer");
    }
  });
  if (!hasQuestionOrInlineImg) {
    accordionChildren.addClass("answer");
  }
  var pElementsInAccordion = $(".accordion-wrapper > p");
  pElementsInAccordion.each(function () {
    if (!$(this).hasClass("question") && !$(this).hasClass("answer")) {
      $(this).addClass("answer");
    }
  });
}
else {
  var lastH3Element = $(".article-template__content h3");
  lastH3Element.addClass("accordion-wrapper-title");
  var titleH3Element = $(".thumb-image");
  var pElements = titleH3Element.nextAll();
  var pElementss = titleH3Element.nextAll("p");
  pElementss.addClass("answer");
  var h4Elements = titleH3Element.nextAll("h4");
  h4Elements.addClass("question");
  var newDiv = $("<div>").addClass("accordion-wrapper");
  newDiv.append(pElements);
  titleH3Element.after(newDiv);
  var accordionChildren = $(".accordion-wrapper > *");
  var hasQuestionOrInlineImg = false;
  accordionChildren.each(function () {
    if ($(this).hasClass("question") || $.trim($(this).text()) !== '') {
      hasQuestionOrInlineImg = true;
    }
    if ($(this).hasClass("inline-img")) {
      hasQuestionOrInlineImg = true;
      $(this).addClass("answer");
    }
    if ($(this).hasClass("center")) {
      hasQuestionOrInlineImg = true;
      $(this).addClass("answer");
    }
  });
  if (!hasQuestionOrInlineImg) {
    accordionChildren.addClass("answer");
  }
  var pElementsInAccordion = $(".accordion-wrapper > p");
  pElementsInAccordion.each(function () {
    if (!$(this).hasClass("question") && !$(this).hasClass("answer")) {
      $(this).addClass("answer");
    }
  });
  var pElementsInAccordioniframe = $(".accordion-wrapper > iframe");
  pElementsInAccordioniframe.each(function () {
    if (!$(this).hasClass("question") && !$(this).hasClass("answer")) {
      $(this).addClass("answer");
    }
  });
}
var accordionWrapper = $(".accordion-wrapper");
var currentQuestion = null;
accordionWrapper.children().each(function () {
  var element = $(this);
  if (element.hasClass("question")) {
    var accordion = $("<div>").addClass("accordion");
    accordion.append(element);
    currentQuestion = element;
    accordionWrapper.append(accordion);
  } else if (element.hasClass("answer")) {
    if (currentQuestion !== null) {
      var accordionContent = currentQuestion.siblings(".accordion-content");
      if (accordionContent.length === 0) {
        accordionContent = $("<div>").addClass("accordion-content");
        accordionContent.insertAfter(currentQuestion);
      }
      accordionContent.append(element);
    }
  }
});
accordionWrapper.find(".answer:not(.accordion .answer)").remove();
$(document).ready(function () {
  $(".accordion:first").addClass("active");
  $(".accordion-content:first").addClass("show");
  $(".question").click(function () {
    var accordion = $(this).parent(".accordion");
    var content = accordion.find(".accordion-content");
    if (!accordion.hasClass("active")) {
      $(".accordion").removeClass("active");
      $(".accordion-content").removeClass("show");
      content.addClass("show");
      accordion.addClass("active");
    } else {
      content.removeClass("show");
      accordion.removeClass("active");
    }
  });
});



})();




